var Menu = (function($) {
  var menuTL;
  var isOpen = false;

  // 👉 tu transición CSS del panel es 0.6s; le damos un pelín extra para que “respire”
  var panelWait = 0.4;

  function buildTimeline() {
    var $nav = $(".header-nav-secondary");
    var $items = $nav.find(".header-menu-secondary__item");
    var $footer = $nav.find(".header-footer");

    // Estado inicial
    gsap.set($items, { opacity: 0, y: 18 });
    gsap.set($footer, { opacity: 0, y: 22 });

    menuTL = gsap.timeline({ paused: true });

    menuTL
      // 1) Espera a que termine el slide del panel (CSS) + un poco de aire
      .to({}, { duration: panelWait })

      // 2) Items stagger más lento
      .to($items, {
        opacity: 1,
        y: 0,
        duration: 0.95, // más lento
        ease: "elastic.out(1, 0.6)", // elástico más sutil (menos rebote)
        stagger: 0.12 // más separación entre items
      })

      // 3) Footer empieza antes de acabar los items (overlap)
      //    "-=0.55" = arranca 0.55s antes de que termine el bloque anterior
      .to(
        $footer,
        {
          opacity: 1,
          y: 0,
          duration: 0.7, // más lento
          ease: "power2.out"
        },
        "-=0.75"
      );
  }

  function openMenu() {
    $("body").addClass("has-nav");
    isOpen = true;
    menuTL.play(0);
  }

  function openWorkMenu() {
    $(".header-submenu-secondary").slideToggle();
    $(".header-menu-secondary__item--expandable")
      .find("a:first")
      .toggleClass("header-menu-secondary__link--expanded");
  }

  function closeMenu() {
    isOpen = false;
    menuTL.reverse();
    $("body").removeClass("has-nav");
  }

  function toggleMenu() {
    if (isOpen) closeMenu();
    else openMenu();
  }

  function init() {
    if (!$(".header-nav-secondary").length || typeof gsap === "undefined")
      return;

    buildTimeline();

    $(".hamburger").on("click", function() {
      toggleMenu();
    });

    $(document).on("keydown", function(e) {
      if (e.key === "Escape" && isOpen) closeMenu();
    });

    $(".header-nav-overlay").on("click", function() {
      if (isOpen) closeMenu();
    });

    $(".header-menu-secondary__item--expandable > a").click(function(e) {
      e.preventDefault();
      openWorkMenu();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
